import { useState, useEffect } from "react";
import InterfaceTable from "../../Table/InterfaceTable";
import { message } from "antd";

const EmissionFactorsBoard = ({
  emissionFactors,
  getEmissionFactors,
  totalEmissionFactors,
}) => {
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    page: 0,
    limit: 5,
  });
  const [filters, setFilters] = useState({});
  const [typeFilters, setTypeFilters] = useState([]);

  const safeEmissionFactors = Array.isArray(emissionFactors) ? emissionFactors : [];

  const columnsEquivalentCodes = [
    {
      title: "Año",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "Factor de emisión",
      dataIndex: "fe",
      key: "fe",
      filters: [
        { text: "Electricidad", value: "electricity" },
        { text: "Combustible", value: "fuel" },
        { text: "Alojamiento", value: "accommodation" },
        { text: "Residuos", value: "waste" },
        { text: "Tipo de transporte", value: "transport_type" },
        { text: "Suministros", value: "supplies" },
      ],
      filteredValue: typeFilters || null,
      onFilter: () => true,
    },
    {
      title: "Unidad de factor",
      dataIndex: "factor_unity",
      key: "factor_unity",
    },
  ];

  const fetchData = async (params = {}) => {
    try {
      setLoading(true);
      await getEmissionFactors({
        limit: values.limit,
        page: values.page,
        ...params,
      });
    } catch (error) {
      message.error("Error al cargar los datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.page, values.limit]);

  const handleRequest = (pagination = {}, antFilters = {}) => {
    const { current = 1, pageSize = values.limit } = pagination;

    const updatedValues = {
      page: current - 1,
      limit: pageSize,
    };

    setValues(updatedValues);

    const selectedTypes = antFilters.fe || [];
    setTypeFilters(selectedTypes);

    const queryParams = {
      page: updatedValues.page,
      limit: updatedValues.limit,
    };

    if (selectedTypes.length > 0) {
      queryParams.type = selectedTypes;
    }

    setFilters(queryParams);
    fetchData(queryParams);
  };

  return (
    <InterfaceTable
      rowKey="id"
      data={safeEmissionFactors}
      columns={columnsEquivalentCodes}
      loading={loading}
      onChange={handleRequest}
      pagination={{
        current: values.page + 1,
        pageSize: values.limit,
        total: totalEmissionFactors || 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
      }}
    />
  );
};

export default EmissionFactorsBoard;